// The Tracked view's Active / Upcoming reminder groups (TrackedReminderGroups). They must be
// declared in the work_orders reducer's initial state: its updateFilters / updatePagination cases
// spread the target collection's existing pagination, so an undeclared collection crashes the first
// fetch ("Cannot read properties of undefined (reading 'pagination')"). Kept import-free so the
// reducer can depend on it without pulling in the thunk layer.
export const TRACKED_ACTIVE_REMINDERS_COLLECTION = 'workOrdersTrackedActiveReminders';
export const TRACKED_UPCOMING_REMINDERS_COLLECTION = 'workOrdersTrackedUpcomingReminders';
// A page-size-1 search whose total says how many of the user's reminders are due — drives the
// Tracked tab icon (ringing red bell vs. star/bell) on every work order view.
export const ACTIVE_REMINDER_COUNT_COLLECTION = 'workOrdersActiveReminderCount';
